import {
  Component,
  Listen,
  Prop,
  State,
  Event,
  h,
  type EventEmitter,
} from '@stencil/core';
import { isMobile } from '../../../utils/media/media';
import {MyProductsBarEventLayer, clickedElement, getCartValue, getProductItems, type ProductEventGa} from './my-products-event-layer';
import type {labelProviderInterface} from '../../LabelProviderInterface';

@Component({
  tag: 'uiaas-my-products-notification-bar',
  styleUrl: 'uiaas-my-products-notification-bar.scss',
  shadow: true,
})
export class MyProductsNotificationBarComponent {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly country: string;
  @Prop() readonly language: string;
  @Prop() readonly term: string;
  @Prop() readonly myProductsCartUrl: string;

  @State() isMobileView = isMobile();
  @State() isMyProductsBarVisible = false;

  private timeoutId = null;
  private myProductsBarCtaData: ProductEventGa;

  @Listen('sidePanel:addToCardClicked', { target: 'document' })
  handleShowMyProductsBarAction(e) {
      this.clearTimeout();
      this.isMyProductsBarVisible = true;
      this.startTimeout();
      if(e.detail) {
        this.myProductsBarCtaData = e.detail;
      }
  }

  @Event({
    eventName: 'notification:myProductsBarCtaEvent',
  })
    myProductsBarActionEventEmitter: EventEmitter;

  private startTimeout() {
      this.timeoutId = setTimeout(() => {
          this.isMyProductsBarVisible = false;
      }, 5000);
  }

  private clearTimeout() {
      this.isMyProductsBarVisible = false;
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
  }

	  private onEnterEventEmitter = (e) =>
    e.key === 'Enter' ? this.eventBuilder(e) : void 0;

  private eventBuilder = (e) => {
      const elementArea = clickedElement(e);
      const myProductsClickArea = 'my_products_link';

      if (elementArea !== myProductsClickArea) return;

      if (elementArea === myProductsClickArea) {
        const { infoForGa, productsUpdated, groupId } = this.myProductsBarCtaData;
        const cartValue = getCartValue(infoForGa, productsUpdated);
        const productItems = getProductItems(infoForGa, productsUpdated, groupId);

        const ecommerce = {
          currency: cartValue.currency,
          value: cartValue.totalPrice?.toString(),
          items: productItems,
        };

        this.myProductsBarActionEventEmitter.emit({
          ecommerce,
        });
      }
  };

  render() {
      return this.isMyProductsBarVisible && (
        <MyProductsBarEventLayer
				  onEnterEventEmitter={(e) => this.onEnterEventEmitter(e)}
          eventBuilder={(e) => this.eventBuilder(e)}
        >
          <div class="my-products-wrapper">
            <div class="my-products-wrapper-bar">
              <div class="my-products-wrapper-bar-content">
                <div class="my-products-wrapper-bar-text">
                  {this.labelProvider(
                    'my-products.add-to-cart',
                    'Item added to your Cart',
                  )}
                </div>
                <div class="my-products-wrapper-bar-link">
                  <qds-button
                    data-my-products-area={'my_products_link'}
                    importance="standard"
                    size={'standard'}
                    text={this.labelProvider(
                      'my-products.view-cart',
                      'View Cart',
                    )}
                    href={this.myProductsCartUrl}
                    target="_blank"
                    class="my-products-wrapper-bar-link-btn"
                  ></qds-button>
                </div>
                <qds-button
                  importance="subdued"
                  icon-name="cross-large"
                  size="small"
                  onClick={() => {
                      this.isMyProductsBarVisible = false;
                  }}
                  icon-only="true"
                ></qds-button>
              </div>
            </div>
          </div>
        </MyProductsBarEventLayer>
      );
  }
}
